import sayitnowLogo from '@/assets/sayitnow-logo.png';

interface AnnouncementWatermarkProps {
  visible: boolean;
}

export function AnnouncementWatermark({ visible }: AnnouncementWatermarkProps) {
  if (!visible) return null;

  // Generate a grid of watermark items
  const items = Array.from({ length: 24 }, (_, i) => i);

  return (
    <div
      className="fixed inset-0 z-40 pointer-events-none overflow-hidden"
      aria-hidden="true"
    >
      <div
        className="absolute inset-[-50%] flex flex-wrap items-center justify-center gap-16"
        style={{
          transform: 'rotate(-30deg)',
          opacity: 0.07,
        }}
      >
        {items.map((i) => (
          <div
            key={i}
            className="flex items-center gap-2 shrink-0"
          >
            <img
              src={sayitnowLogo}
              alt=""
              className="h-8 w-8 object-contain"
              draggable={false}
            />
            <span className="font-heading font-bold text-foreground text-lg whitespace-nowrap tracking-tight">
              Say It <span className="text-primary">NOW</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
